<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="main_wrap" v-show="shown.mainshow">
        <div class="head_wrap"></div>
        <div class="body_wrap">
          <div class="copyright">
            Copyright© {{ this.pageData.currentYear }} iFi Audio
            www.ifipartnerstore.com - www.ifi-audio.com
          </div>
        </div>
        <div class="foot_wrap"></div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shown: {
        mainshow: false
      },
      pageData: {
        currentYear: ''
      },
      formData: {},
    };
  },
  mounted() {
    this.getYear();
    setTimeout(() => {
      this.shown.mainshow = true;
    }, 1);
  },
  methods: {
    getYear() {
      this.pageData.currentYear = new Date().getFullYear();
    }
  },
};
</script>

<style scoped>
.body_wrap {
  width: 100%;
  color: #606266;
  display: table;
  margin-top: 3rem;
  font-size: 0.9rem;
}
.copyright {
  height: 1rem;
  padding: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/customerCommonFooter.vue